import { paths as CustomerCommunicationPaths } from '@luxuryescapes/contract-customer-communication';

import { json_headers, request } from '~/services/common';

import { makeCustomerCommunicationV1URL } from './customerCommunicationRequestUtils';

type HeroPlannerSchedulePatchContract =
  CustomerCommunicationPaths['/api/customer-communication/v1/todays-escapes-schedule/hero-planner/schedules/{scheduleId}']['patch'];

function mapEditedExternalHeroPlannerSchedule(
  internal: CustomerCommunication.UnsavedHeroPlannerSchedule,
): HeroPlannerSchedulePatchContract['requestBody']['content']['application/json']['schedule'] {
  const pushSchedules = internal.pushSchedules?.map((pushSchedule) => {
    return {
      title: pushSchedule.title,
      subtitle: pushSchedule.subtitle,
      message: pushSchedule.message,
      link: pushSchedule.link,
      imageId: pushSchedule.imageId,
      scheduleType: pushSchedule.scheduleType,
      status: 'PENDING' as const,
    };
  });
  type Schedule = HeroPlannerSchedulePatchContract['requestBody']['content']['application/json']['schedule'];
  return {
    identifiers: {
      brand: internal.brandId as Schedule['identifiers']['brand'],
      country: internal.countryId as Schedule['identifiers']['country'],
      countryGroup: internal.countryGroupId as Schedule['identifiers']['countryGroup'],
      state: internal.stateId as Schedule['identifiers']['state'],
      segment: internal.segmentId as Schedule['identifiers']['segment'],
      city: internal.cityId as Schedule['identifiers']['city'],
      cadence: internal.cadenceId as Schedule['identifiers']['cadence'],
      loyalty: internal.membershipId as Schedule['identifiers']['loyalty'],

      sendDate: internal.sendDate.format('YYYY-MM-DD'),
    },
    data: {
      emailSubjectLine: internal.emailSubjectLine,
      emailPreheader: internal.emailPreHeader,
      emailBannerId: internal.emailBannerId,
      emailBannerPosition2Id: internal.emailBannerPosition2Id,
      emailHeroDeals: internal.emailHeroOfferIds,
      emailStatus: 'PENDING',
      isApprovedForTpfm: internal.isApprovedForTpfm,
      pushOfferId: internal.emailHeroOfferIds[0],
      pushTitle: internal.pushTitle,
      pushSubtitle: internal.pushSubtitle,
      pushMessage: internal.pushMessage,
      pushLink: internal.pushLink,
      pushImageId: internal.pushSvcImageId,
      pushStatus: 'PENDING',
      pushSchedules,
    },
  };
}

async function requestPatchHeroPlannerSchedule(
  scheduleId: string,
  unsavedSchedule: CustomerCommunication.UnsavedHeroPlannerSchedule,
) {
  if (!scheduleId) throw 'missing scheduleId';
  if (!unsavedSchedule) throw 'missing unsavedSchedule';

  const url = makeCustomerCommunicationV1URL(`/todays-escapes-schedule/hero-planner/schedules/${scheduleId}`);

  return request(url.toString(), {
    method: 'PATCH',
    credentials: 'include',
    headers: json_headers,
    body: JSON.stringify({ schedule: mapEditedExternalHeroPlannerSchedule(unsavedSchedule) }),
  }).catch((error) => {
    throw JSON.stringify(error, null, 2);
  });
}

export default requestPatchHeroPlannerSchedule;
